import AScene from "../../library/ExtendedObjects/AScene.js";
import Game_UI from "./Game_UI.js";
import Game from "./Game.js";
import gameData from "../../gameData.js";
import { Audio } from "@abcya/abcya_phaser";
import LocalizationSoundAssetKeys from "../../Localization-SoundAssetKeys.js";
import ABCyaLib from "@abcya/abcya_lib";

export default class Game_Title
{
    /**
     * @param {Game} scene 
     * @param {Game_UI} parent 
     */
    constructor(scene, ui)
    {
        this.scene = scene;
        this.ui = ui;

        this.text_Make = this.scene.addText(this.scene.mid.x - 45, 37, "Make:", 34, null, 1, this.ui, "Dosis-Bold");
        this.text_Make.tint = 0xFFFEE0;
        this.subText_Make = this.scene.addText(this.scene.mid.x, 90, "Drag and drop the snakes\nfrom the notebook", 16, null, 1, this.ui);
        this.subText_Make.tint = 0xFFFEE0;

        this.number_Make = this.scene.addText(this.scene.mid.x + 5, 37, "800", 65, null, 0, this.ui, "Dosis-Bold").setOrigin(0, .5);
        this.number_Make.tint = 0xFFFEE0;
        this.speaker_Make = this.scene.addButton(this.scene.mid.x + 40, 35, "listen_icon", {tintOnDown: 0xaaaaaa}, ()=>{
            this.speakNumber();
        }, this.ui);

        this.text_Count = this.scene.addText(this.scene.mid.x, 37, "Count the\nsegments!", 34, null, 1, this.ui, "Dosis-Bold");
        this.text_Count.tint = 0xFFFEE0;
        this.subText_Count = this.scene.addText(this.scene.mid.x, 95, "Write your answer\ninto the notebook.", 16, null, 1, this.ui);
        this.subText_Count.tint = 0xFFFEE0;

        this.uiElements = [];
        this.uiElements.push(this.text_Make);
        this.uiElements.push(this.subText_Make);
        this.uiElements.push(this.number_Make);
        this.uiElements.push(this.speaker_Make);
        this.uiElements.push(this.text_Count);
        this.uiElements.push(this.subText_Count);
    }

    setNumber(number, isInit)
    {
        if((gameData.curGameType == "LISTEN" && !isInit) || (gameData.curGameType === 'READ' && ABCyaLib.Environment.instance.gameConfig.subtitle !== null && !isInit))
        {
            if(this.scene.playUnlockedVO) //WAIT UNTIL UNLOCKED VO IS FINISHED TO PLAY SOUND
            {
              // Logic to ensure delay is as long as it needs to be for GB/AU/US
              const soundPath1 = this.scene.sound.jsonCache.get(Audio.LOCALIZATION_AUDIO_SPRITE).spritemap[LocalizationSoundAssetKeys._five_correct_in_a_row];
              const soundPath2 = this.scene.sound.jsonCache.get(Audio.LOCALIZATION_AUDIO_SPRITE).spritemap[LocalizationSoundAssetKeys._change_your_snake_style];
              const soundLength1 = Math.ceil(soundPath1.end - soundPath1.start) * 1000;
              const soundLength2 = Math.ceil(soundPath2.end - soundPath2.start) * 1000;
              const delayLength = soundLength1 + soundLength2;

                this.scene.addDelay(delayLength, ()=>{this.speakNumber();});
            } 
            else
            {
                this.speakNumber();
            }
        }
        this.number_Make.text = number;
    }

    speakNumber()
    {
        let num = this.scene.curNumber;
        if(this.curDelay) this.curDelay.remove();

        if (num < 20) {
            this.speak(num);
        }
        else {
            let onesDigit = num % 10;
            let tensDigit = Math.floor(num % 100 / 10);
            let hundredsDigit = Math.floor(num / 100);

            if(hundredsDigit != 0)
            {
                this.curDelay = this.scene.addDelay(this.speak(hundredsDigit).duration * 1000, ()=>{
                    this.curDelay = this.scene.addDelay(this.speak(100).duration * 1000, ()=>{
                        if(tensDigit == 0)
                        {
                            this.speak(onesDigit);
                        }
                        else if(tensDigit == 1)
                        {
                            this.speak(tensDigit * 10 + onesDigit);
                        }
                        else
                        {
                            this.curDelay = this.scene.addDelay(this.speak(tensDigit * 10).duration * 1000, ()=>{
                                this.speak(onesDigit);
                            });
                        }
                    });
                });
            }
            else
            {
                if (tensDigit == 1) {
                    this.speak(tensDigit * 10 + onesDigit);
                }
                else {
                    this.curDelay = this.scene.addDelay(this.speak(tensDigit * 10).duration * 1000, () => {
                        this.speak(onesDigit);
                    });
                }
            }
        }
    }

    speak(key)
    {
        if(key == 0) return {duration: 0};
        if(this.spokenKey) this.spokenKey.stop();
        this.spokenKey = this.scene.playSound(key.toString(), 1, false, true, Audio.LOCALIZATION_AUDIO_SPRITE);
        return this.spokenKey;
    }

    hideElements()
    {
        for(let i = 0; i < this.uiElements.length; i++)
        {
            this.uiElements[i].alpha = 0;
        }
    }

    setState(state)
    {
        this.hideElements();

        if(state == this.scene.states.READ)
        {
            this.text_Make.alpha = 1;
            this.subText_Make.alpha = 1;
            this.number_Make.alpha = 1;
        }
        else if(state == this.scene.states.COUNT)
        {
            this.text_Count.alpha = 1;
            this.subText_Count.alpha = 1;
        }
        else if(state == this.scene.states.LISTEN)
        {
            this.text_Make.alpha = 1;
            this.subText_Make.alpha = 1;
            this.speaker_Make.alpha = 1;
        }
    }
}